import { useContext, useEffect } from 'react'
import useUniqueId from '../use-unique-id'
import { ScrollLockContext } from './scroll-lock-context'

export const useScrollLock = (show: boolean) => {
  const id = useUniqueId('scroll-lock')
  const { requestScrollLock, releaseScrollLock } = useContext(ScrollLockContext)

  useEffect(() => {
    if (show) {
      requestScrollLock(id)
    } else {
      releaseScrollLock(id)
    }

    return () => {
      releaseScrollLock(id)
    }
  }, [id, show])
}
